import {
  GlobalCss,
  RecoilRoot,
  ThemeProvider,
} from "@mostrans/web-components/providers";
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom/cjs/react-router-dom";
import App from "./App";

ReactDOM.render(
  <HashRouter>
    <RecoilRoot>
      <ThemeProvider>
        <GlobalCss />
        <App />
      </ThemeProvider>
    </RecoilRoot>
  </HashRouter>,
  document.getElementById("root")
);
